import gql from 'graphql-tag';

export const getSchedulesV2 = gql`
  query getSchedules($date: Float!, $periods: [String!]) {
    scheduleByDate(
      filters: {
        date: $date
        classTypes: [1, 2, 3, 4, 5, 6]
        periods: $periods
      }
    ) {
      dates {
        date
        items {
          name
          typeSchedule {
            id
            name
          }
          modality {
            id
            name
            location
          }
          hasCrossing
          isRescheduled
          period
          date
          startTime
          endTime
          class {
            id
            start
            end
            type
            classType
            descAmb
            professors {
              firstName
              lastName
            }
            location {
              classRoom {
                desc
                id
                floor
              }
              building {
                id
                image
                desc
                address
                coordinates {
                  latitude
                  longitude
                }
              }
            }
            professors {
              firstName
              lastName
            }
            instructionMode
            isReprog
            name
            desc
            linkZoom
            hours
            isClass
            isHybrid
            linkCourseClass
          }
        }
      }
    }
  }
`;

export const getScheduleByDayV2 = gql`
  query getSchedulesH($date: Float!, $classTypes: [Float!], $period: String!) {
    schedulesHomeV2(
      filters: { date: $date, classTypes: $classTypes, period: $period }
    ) {
      items {
        weekId
        start
        end
        id
        name
        isClass
        desc
        type
        classType
        instructionMode
        isReprog
        location {
          classRoom {
            id
          }
        }
      }
    }
  }
`;
export const getScheduleResume = gql`
  query getScheduleResumeHome($periodId: String!) {
    getScheduleResumeHome(periodId: $periodId) {
      day
      dayName
      courseId
      type
      start
      end
      sectionId
      desdobGroup
      desdobType
      name
      classroom
    }
  }
`;
